import PropTypes from 'prop-types'

import paymentMethodPropType from '~/utils/propTypes/paymentMethod'
import AddressPropTypes from '~/utils/propTypes/address'
import DineroPropShape from '~/utils/propTypes/dinero'

export const PayeePropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  branchCode: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired,
  businessNumber: PropTypes.string.isRequired,
})

const PaymentPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  payee: PayeePropType.isRequired,
  netPaymentAmount: DineroPropShape.isRequired,
  grossPaymentAmount: DineroPropShape.isRequired,
  marmaladePointsEarnt: PropTypes.number.isRequired,
  paymentReference: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  paymentMethod: paymentMethodPropType.isRequired,
  mcoinFeeTaxInvoiceAvailable: PropTypes.bool,
})

export const OfferPropType = PropTypes.shape({
  pointsFeeRate: PropTypes.string.isRequired,
  taxRate: PropTypes.number.isRequired,
})

export const PayablePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  payeeName: PropTypes.string,
  dueDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  issueDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  dueAmount: DineroPropShape.isRequired,
  address: AddressPropTypes,
  lifecycleStatus: PropTypes.string.isRequired,
  offer: OfferPropType,
  payee: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    bankAccount: PropTypes.shape({
      bsb: PropTypes.string,
      accountNumber: PropTypes.string,
    }),
    businessNumber: PropTypes.string,
    lockVersion: PropTypes.number,
  }),
})

export const StepPropType = PropTypes.shape({
  state: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.func,
})

export default PaymentPropType
